import styled from "styled-components"

export default function OrderProductInfoSection({ title, children }) {
  return (
    <Section>
      <OrderInfoTitle>{title}</OrderInfoTitle>
      {children}
    </Section>
  )
}

const Section = styled.div`
  padding: calc(100vw * (24 / 375)) 0 calc(100vw * (32 / 375)) 0;
`

const OrderInfoTitle = styled.h2`
  font-size: calc(100vw * (16 / 375));
  font-weight: 600;
  line-height: calc(100vw * (19 / 375));
  margin-bottom: calc(100vw * (16 / 375));
`
